const ns = "ASSET_REPORTS_V2_PORTAL";
export const RECEIVE_ASSETS_REPORT = `${ns}_RECEIVE_ASSETS_REPORT`;
export const RECEIVE_CREDENTIALS_REPORT = `${ns}_RECEIVE_CREDENTIALS_REPORT`;
export const RECEIVE_CATERING_REPORT = `${ns}_RECEIVE_CATERING_REPORT`;
